export const API_ENDPOINTS = {
  SIGN_IN: '/api/v1/admin/auth/login',
  SIGN_OUT: '/api/v1/admin/auth/logout',
  REFRESH_TOKEN: '/api/v1/refresh-tokens/refresh',
  USER_PREFERENCES: '/api/v1/users/preferences',
  USERS: '/api/v1/admin/users',
  PROFILE: '/api/v1/users/profile',
  ME: '/api/v1/users/me',
  CHANGE_AVATAR: '/api/v1/users/change-avatar',
  CONTENTS: '/api/v1/admin/contents',
  POSTS: '/api/v1/admin/posts',
  FILES: '/api/v1/files',
  FILES_UPLOAD: '/api/v1/files/upload',
  NOTIFICATIONS: '/api/v1/admin/notifications',
  AUDIT_LOGS: '/api/v1/admin/audit-logs',
  CONTACTS: '/api/v1/admin/contacts',
  ENGAGEMENT_ACTIVITIES: '/api/v1/admin/engagement-activities',
  ENGAGEMENT_APPROVALS: '/api/v1/engagement-approvals',
  BULK_ENGAGEMENT_APPROVALS: '/api/v1/engagement-approvals/bulk',
  FACTS: '/api/v1/facts',
  RULE_CONFIGURATION: '/api/v1/rule-configurations',
  REWARDS: '/api/v1/admin/rewards',
  REWARD_CATEGORIES: '/api/v1/reward-categories',
  REWARD_REDEMPTIONS: '/api/v1/reward-redemptions',
  ADMIN_REWARD_CATEGORIES: 'api/v1/admin/reward-categories',
  DYNAMIC_POINT_RATE: '/api/v1/dynamic-point-rate',
  ADMIN_BANNERS: '/api/v1/admin/banners',
  SERVICES: '/api/v1/services',
  SERVICE_APPROVALS: '/api/v1/service-approvals',
};
